module.exports = __webpack_public_path__ + "img/logo-wh.5cc0da09.svg";